import type { ProgressStep } from '../lib/useStreamingAnalysis';

/** Agent progress as a quiet list; the newest step carries the blue marker. */
export function ProgressSteps({ steps, active }: { steps: ProgressStep[]; active: boolean }) {
  if (!steps.length) return null;
  return (
    <ol className="mt-4 flex flex-col gap-2">
      {steps.map((s, i) => {
        const current = active && i === steps.length - 1;
        return (
          <li key={`${s.step}-${i}`} className="flex items-center gap-3">
            <span className={`num text-[11px] ${current ? 'text-blue' : 'text-faint'}`}>{String(i + 1).padStart(2, '0')}</span>
            <span className={`h-[2px] w-4 shrink-0 ${current ? 'bg-blue' : 'bg-line'}`} aria-hidden="true" />
            <span className={`font-cond text-[15px] uppercase tracking-[0.06em] ${current ? 'font-semibold text-ink' : 'text-muted'}`}>{s.message}</span>
          </li>
        );
      })}
    </ol>
  );
}
